import React, { useEffect } from "react";
import { Button, notification } from "antd";
import SummaryReport from "./Summary";
import { Tooltip, Typography } from "@mui/material";

const App = () => {
  const [api, contextHolder] = notification.useNotification();

  const openNotification = () => {
    api.open({
      description: <SummaryReport />,
      duration: 20,
      placement: "bottomRight",
      style: { minWidth: "500px" },
      pauseOnHover: true,
    });
  };

  useEffect(() => {
    openNotification();
  }, []); // Empty dependency array ensures this runs once when the component mounts

  return (
    <>
      {contextHolder}

      <div
        className='bounce-button'
        style={{
          position: "fixed",
          bottom: "10%",
          right: "2%",
          zIndex: 100,
        }}>
        <Tooltip title='Show Summary'>
          <Button
            onClick={openNotification}
            className='new_claim_add'
            size='large'
            style={{
              backgroundColor: "#3D4F58",
              zIndex: 100,
              textTransform: "capitalize",
            }}>
            <Typography style={{ color: "#ffffff" }}>Summary Report</Typography>
          </Button>
        </Tooltip>
      </div>
    </>
  );
};

export default App;
